
import { Component, Mixins } from 'vue-property-decorator';
import EditableItem from '~/components/RemoteFeatureFlags/Groups/EditableItem.vue';
import FlagsSelector from '~/components/RemoteFeatureFlags/Groups/FlagsSelector.vue';
import { RemoteFeatureFlagsModule } from '~/store/modules/remoteFeatureFlags';
import DarkThemeInfoMixin from '~common-mixins/DarkThemeInfoMixin';

@Component({
    components: {
        EditableItem,
        FlagsSelector
    }
})
export default class GroupsCreator extends Mixins(DarkThemeInfoMixin) {
    valid = false;
    groupName = '';
    selectedFlagIds: string[] = [];

    async create() {
        await RemoteFeatureFlagsModule.createGroup({
            name: this.groupName
        });
        (this.$refs.editableItem as any)?.$refs?.form?.resetValidation();
        this.resetFields();
    }

    resetFields() {
        this.groupName = '';
        this.selectedFlagIds = [];
        this.valid = false;
    }
}
